import AdminLayout from '@/layouts/admin/AdminLayout.vue'
import {useAuthentication} from '@/services/useAuthentication.ts'

const { beforeEnter } = useAuthentication()

export default [
  {
    path: '/cliente',
    beforeEnter,
    component: AdminLayout,
    children: [
      {
        path: '',
        name: 'cliente-dashboard',
        meta: {
          title: 'Dashboard',
          requiresRole: 'cliente',
        },
        component: () => import('@/views/cliente/DashboardPage.vue'),
      },
      {
        path: 'vetture',
        name: 'cliente-vetture',
        meta: {
          title: 'Vetture',
          requiresRole: 'cliente',
        },
        component: () => import('@/views/cliente/VetturePage.vue'),
      },
    ],
  },
]
